/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconSchemaDiff = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 27"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 27px;
      `}
      {...props}
    >
      <g
        fill={fill}
        fillRule="evenodd"
        stroke={stroke}
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M16.583 5.972c.782 0 1.417.712 1.417 1.59v16.705c0 .878-.635 1.591-1.417 1.591H2.417c-.782 0-1.417-.713-1.417-1.591V7.563c0-.879.635-1.591 1.417-1.591h14.166z" />
        <path d="M6 6V2.59C6 1.714 6.635 1 7.417 1h14.166C22.365 1 23 1.713 23 2.59v16.705c0 .879-.635 1.591-1.417 1.591H18" />
        <path
          strokeLinecap="round"
          d="M9.5 10.943v4.972M7 13.429h5M7 19.395h5"
        />
      </g>
    </svg>
  ),
);
